import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";

const baseUrl = "https://api.shabdtoday.com/";
const baseUrlLocal = "https://localhost:44351/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";
const apiEndpointlocal = "https://localhost:44351/api/home/getOpinionById"; // ✅ Use the correct API
const apiEndpoint = "https://api.shabdtoday.com/api/home/getOpinionById"; // ✅ Use the correct API

const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength);
    }
    return text;
};

const local_Count = "https://localhost:44351/api/home/update-viewcountOpinion"
const online_Count = "https://api.shabdtoday.com/api/home/update-viewcountOpinion"

const stripHtmlTags = (html, maxLength) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const strippedText = tempDiv.textContent || tempDiv.innerText || "";
    return truncateText(strippedText, maxLength);
};

const OpinionWithIdCard = () => {
    const { id } = useParams();
    const [opinions, setOpinions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const observer = useRef(null);

    const fetchOpinions = async () => {
        if (!id || fetching || !hasMore) return;

        setFetching(true);
        try {
            const response = await axios.get(`${apiEndpoint}?page=${page}&limit=5&mainKhabarId=${id}`);
            const newOpinions = response.data?.opinionWithMemberList || []; // ✅ Ensure it's an array

            if (newOpinions.length > 0) {
                setOpinions((prevOpinions) => {
                    const existingIds = new Set(prevOpinions.map((item) => item.id));
                    const filteredOpinions = newOpinions.filter((item) => !existingIds.has(item.id));
                    return [...prevOpinions, ...filteredOpinions];
                });
                setPage((prevPage) => prevPage + 1);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching opinions:", error.message);
            setError(error.message);
        }
        setFetching(false);
        setLoading(false);
    };

    useEffect(() => {
        setOpinions([]); // Clear previous data
        setPage(1);
        setHasMore(true);
        setLoading(true);
        fetchOpinions();
    }, [id]);

    useEffect(() => {
        if (!hasMore || fetching) return; // Stop if no more data

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchOpinions();
            }
        });

        const target = document.getElementById("load-more");
        if (target) observer.current.observe(target);

        return () => observer.current && observer.current.disconnect();
    }, [hasMore, fetching]);

    const handleNewsClick2 = async (id) => {
        try {
            const response = await axios.post(local_Count, {
                MainKhabarId: id
            });

            if (response.status === 200) {
                // console.log("View count updated successfully", response.data);
               window.location.href =`/Opinions_Details/${id}`;
            } else {
                console.error("Failed to update view count", response.data);
            }
        } catch (error) {
            console.error("Error updating view count:", error.response ? error.response.data : error.message);
        }
    };

    const formatDateInHindi = (dateString) => {
        const date = new Date(dateString);
        const monthsInHindi = [
            "जनवरी",
            "फरवरी",
            "मार्च",
            "अप्रैल",
            "मई",
            "जून",
            "जुलाई",
            "अगस्त",
            "सितंबर",
            "अक्टूबर",
            "नवंबर",
            "दिसंबर",
        ];
        const seconds = date.getSeconds();
        const minute = date.getMinutes();
        var hour = date.getHours();
        const day = date.getDate();
        const month = monthsInHindi[date.getMonth()];
        const year = date.getFullYear();
        const amPm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
    };

    const generateShareLinks = (id, opinion_Heading) => {
        const encodedopinion_Heading = encodeURIComponent(opinion_Heading);
        const url = `${window.location.origin}/TajaKhabarDetailsNews/${id}`;
        return {
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedopinion_Heading}`,
            whatsapp: `https://api.whatsapp.com/send?text=${encodedopinion_Heading} ${url}`,
            twitter: `https://twitter.com/intent/tweet?text=${encodedopinion_Heading}&url=${url}`,
            instagram: `https://www.instagram.com/`
        };
    };

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                {/* <Circles height="30" width="30" color="#f7265c" ariaLabel="loading" visible={true} /> */}
            </div>
        );
    }

    if (error) {
        return <div style={{ textAlign: "center", padding: "20px", color: "red" }}>Error: {error}</div>;
    }

    return (
        <div>
            <div className="row vc_row">
                <div className="ak_vc_container">
                    <div className="wpb_column ak_column_3 vc_column_container">
                        <div className="ak_vc_wrapper wpb_wrapper">
                            <div className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix" id="block_65f7f61f36732_2">
                                <div className="ak-block-inner clearfix">
                                    <div
                                        className="ak-block-posts clearfix"
                                        style={{
                                            display: "flex",
                                            justifyContent: opinions.length === 1 ? "center" : "space-around",
                                            flexWrap: "wrap",
                                            gap: "20px"
                                        }}
                                    >
                                        {opinions.length > 0 ? (
                                            opinions.map((opinion) => (
                                                <article
                                                    key={opinion.id}
                                                    className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news"
                                                    style={{
                                                        maxWidth: "400px",
                                                        margin: opinions.length === 1 ? "auto" : "initial",
                                                        flex: "1 1 300px"
                                                    }}
                                                >
                                                    <div className="ak-module-inner clearfix">
                                                        <div className="ak-module-featured">
                                                            <div className="ak-module-badges" />
                                                            <div className="ak-featured-cover">
                                                                <Link
                                                                    to="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleNewsClick2(opinion.id);
                                                                    }}
                                                                    className="ak-featured-link"
                                                                    rel="bookmark"
                                                                    aria-label="Shabd Today"
                                                                    title={stripHtmlTags(opinion.opinion_Heading, 150)}
                                                                >
                                                                    <div className="ak-featured-thumb  size-500">
                                                                        <img
                                                                            fetchpriority="high"
                                                                            decoding="async"
                                                                            width={410}
                                                                            height={300}
                                                                            loading="lazy"
                                                                            style={{ objectFit: "fill" }}
                                                                            src={baseUrlLocal + opinion.opinion_Image}
                                                                            className="attachment-newsy_360x180 size-newsy_360x180 lazyload wp-post-image"
                                                                            alt={stripHtmlTags(opinion.opinion_Heading, 150)}
                                                                            data-src={baseUrlLocal + opinion.opinion_Image}
                                                                            data-sizes="auto"
                                                                            data-srcset={baseUrlLocal + opinion.opinion_Image}
                                                                            data-expand={700}
                                                                        />
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                            <div className="ak-module-terms badge" />
                                                        </div>
                                                        <div className="ak-module-details">
                                                            <h1 className="ak-module-title">
                                                                <Link
                                                                    to="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleNewsClick2(opinion.id);
                                                                    }}
                                                                    rel="bookmark"
                                                                    aria-label="Shabd Today"
                                                                    title={stripHtmlTags(opinion.opinion_Heading, 150)}
                                                                >
                                                                    <span style={{ color: "crimson", marginRight: 3, fontSize: 18 }}>{stripHtmlTags(opinion.opinion_Tag, 60)}:</span>
                                                                    {stripHtmlTags(opinion.opinion_Heading, 150)}
                                                                </Link>
                                                            </h1>
                                                            <span className="tm-stmp">
                                                                <i className="ak-icon akfi-schedule me-1" />
                                                                {formatDateInHindi(opinion.opinion_Date)}
                                                            </span>
                                                        </div>
                                                        <Link
                                                            to={`/OpinionAccordingTomember/${opinion.member_Id}`}
                                                            className="ak-module-footer"
                                                            style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "inherit" }}
                                                        >
                                                            <img
                                                                src={baseUrl + opinion.member_Image}
                                                                alt={opinion.member_Name}
                                                                className="author-image"
                                                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                                                            />
                                                            <div>
                                                                <span className="author-name" style={{ fontWeight: "bold" }}>{opinion.member_Name}</span>
                                                                <br />
                                                                <span className="tm-stmp">
                                                                    <i className="ak-icon akfi-schedule me-1" />
                                                                    {formatDateInHindi(opinion.opinion_Date)}
                                                                </span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </article>
                                            ))
                                        ) : (
                                            <p style={{ textAlign: "center", padding: "20px" }}>No opinions available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
                {fetching && <p>Loading more opinions...</p>}
                {!hasMore && <p>No more opinions available.</p>}
            </div>
        </div>
    );
};

export default OpinionWithIdCard;
